import { studioPlayerApi } from "../../api/studioPlayerApi";

export const studioPlayerApiMap = () => studioPlayerApi;